export const SET_TASK_ASSIGNEE = 'SET_TASK_ASSIGNEE';
export const SET_TASK_ASSIGNEES = 'SET_TASK_ASSIGNEES';
export const SET_TASK_RECENT_ASSIGNEES = 'SET_TASK_RECENT_ASSIGNEES';
export const SET_TASK_FIELD = 'SET_TASK_FIELD';
export const SET_TASK_FIELDS = 'SET_TASK_FIELDS';
export const ADD_NEW_SUBJECT = 'ADD_NEW_SUBJECT';
export const SET_TASK_SUBJECTS = 'SET_TASK_SUBJECTS';
export const REMOVE_MY_SUBJECT = 'REMOVE_MY_SUBJECT';
export const SET_TASK_SUCCESS = 'SET_TASK_SUCCESS';
export const RESET_TASK = 'RESET_TASK';
export const SET_DEFAULT_STATE = 'SET_TASK_DEFAULT_STATE';
export const SET_ROUTE_INFO = 'SET_ROUTE_INFO';
export const SET_RELATED_TOS = 'SET_RELATED_TOS';
export const SET_RELATED_TO = 'SET_RELATED_TO';


// WEBPACK FOOTER //
// ./src/components/page/TaskDetails/flow/actionTypes.js